import React from 'react';
import "./services.css"

const servicesData = [
    {
        title: "Residential Waste Collection",
        icon: "fas fa-home",
        features: [
            "Weekly collections",
            "Recycling services",
            "Bulk waste pickup"
        ]
    },
    {
        title: "Commercial Waste Management",
        icon: "fas fa-building",
        features: [
            "Custom collection schedules",
            "Waste audits",
            "Compliance management"
        ]
    },
    {
        title: "Waste Recycling Services",
        icon: "fas fa-recycle",
        features: [
            "Material sorting",
            "Electronics recycling",
            "Recycling reports"
        ]
    }
];

const Services = () => {
    return (
        <div className="services" id="services">
            <h2>Our Waste Management Services</h2>
            <p>Comprehensive solutions for all your waste management needs, focusing on sustainability and efficiency.</p>
            <div className="service-cards">
                {servicesData.map((service, index) => (
                    <div className="service-card" key={index}>
                        <h3><i className={service.icon}></i> {service.title}</h3>
                        <ul>
                            {service.features.map((feature, idx) => (
                                <li key={idx}><i className="fas fa-check-circle"></i> {feature}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Services;